"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
const react_1 = __importDefault(require("react"));
const MobileNavigation_1 = require("./MobileNavigation");
require("./navigation.scss");
const consts_1 = require("../../common/consts");
const Navigation = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("nav", { className: "navigation" },
            react_1.default.createElement("a", { href: `#${consts_1.SECTION_IDS.about}` }, "About"),
            react_1.default.createElement("a", { href: `#${consts_1.SECTION_IDS.events}` }, "Events"),
            react_1.default.createElement("a", { href: `#${consts_1.SECTION_IDS.hosts}` }, "Hosts"),
            react_1.default.createElement("a", { href: `#${consts_1.SECTION_IDS.contact}` }, "Contact Us")),
        react_1.default.createElement(MobileNavigation_1.MobileNavigation, null)));
};
exports.Navigation = Navigation;
